import React, { FC } from 'react';
import classNames from 'classnames/bind';

import styles from './index.pcss';
import Image from '../../../../../atoms/ImageView';
import Text from '../../../../../atoms/Text';

export interface CircleCardProps {
  image: string;
  alt?: string;
  date: string;
  label: string;
  price: string;
}
const cx = classNames.bind(styles);

const CircleCard: FC<CircleCardProps> = (props: CircleCardProps) => {
  const { image = '', alt = '', date = '', label = '', price = '' } = props;

  return (
    <div className={cx('circle-container')}>
      <div className={cx('circle-image')}>
        <div>
          <Image src={image} alt={alt} />
        </div>
      </div>
      <div className={cx('circle-details')}>
        <div>
          <Text variant="T3" color="Nero" weight="regular" textTransform="is-capitalized">
            {date}
          </Text>
        </div>
        <div>
          <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized">
            {label}
          </Text>
        </div>
        <div>
          <Text variant="T3" color="Nero" weight="regular" textTransform="is-capitalized">
            {price}
          </Text>
        </div>
      </div>
    </div>
  );
};

CircleCard.defaultProps = {
  image: '',
  alt: '',
  date: '',
  label: '',
  price: ''
};

export default CircleCard;
